import React, { useState, useEffect } from 'react';
import { Astyle } from './cssForComponents';
import { generalStyleDivs } from '../styles.js';

function IndividualCarroucel(prop) {
    let [countImgShowing, setCountImgShowing] = useState(0);
    const [imageSrc, setImageSrc] = useState(prop.carroucelImg[countImgShowing].url);
    const [arrowSrcLeft, setArrowSrcLeft] = useState("./img/leftArrow.png");
    const [arrowSrcRight, setArrowSrcRight] = useState("./img/rigthArrow.png");
    let totalImagesCount = prop.carroucelImg.length;

    let arrowPositions = {
        left: "",
        right: ""
    }
    let imageWidth = "";

    let BoxStyles = {
        ...generalStyleDivs,
        height: "100%",
        textAlign: "center",
        '&:hover': {
          backgroundColor: 'primary.dark',
        }
    };

    if (prop.isLargeScreen) {
        BoxStyles.width = "25%";
        arrowPositions.left = "-41%";
        arrowPositions.right = "-41%";
        imageWidth = "90%";
    } else if (prop.isSmallScreen) {
        BoxStyles.width = "95%";
        BoxStyles.margin = "10px";
        
        arrowPositions.left = "-45%";
        arrowPositions.right = "-45%";
        imageWidth = "100%";
    }

    if (prop && prop.arrows === "white" && arrowSrcLeft !== './img/whiteLeftArrow.png') {
        setArrowSrcLeft('./img/whiteLeftArrow.png');
        setArrowSrcRight('./img/whiteRigthArrow.png');
    }
    
    useEffect(() => {
        
    }, []); 

    const imgRotation = (event) => {
        let imgToShow = countImgShowing;
        if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "left") {
            if ((imgToShow -1) >= 0) {
                imgToShow = imgToShow - 1;
            } else if((imgToShow -1)  <= 0) {
                imgToShow = totalImagesCount - 1;
            }
        } else if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "right") {
            if ((imgToShow +1) <= (totalImagesCount -1) ) {
                imgToShow = imgToShow + 1;
            } else if((imgToShow +1) >= (totalImagesCount -1)) {
                imgToShow = 0;
            }
        }
        setCountImgShowing(imgToShow);
        setImageSrc(prop.carroucelImg[imgToShow].url);
    }

    return (
        <div style={BoxStyles}>
            <div style={{height: "50%"}}>
                <img src={imageSrc} width={imageWidth} style={{ maxWidth: "230px", maxHeight: "240px", paddingTop: "10px", borderRadius: "20px"  }} alt='' />
                { prop.carroucelImg.length > 1 && 
                <div style={{ position: "relative", top: "-45%", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ textAlign: "right"}}>
                        <img src={arrowSrcLeft} width="15px" height="15px" orientation="left"  onClick={imgRotation} alt=''/>
                    </div>
                    <div style={{ textAlign: "right"}}>
                        <img src={arrowSrcRight} width="15px" height="15px" orientation="right"  onClick={imgRotation} alt=''/>
                    </div>
                </div>
                }
            </div>
            <a href={prop.url} style={Astyle}>
                <div style={{height: "35%"}}>
                    <div style={{ paddingTop: "10px" }} >
                        <div style={{ fontSize: prop.fontSize, fontWeight: "600", padding: "10px", textAlign: "center" }}>
                            {prop.title}
                        </div>
                        <div style={{ fontSize: prop.fontSize, padding: "10px", textAlign: "justify", lineHeight: "1.1", minHeigh: "90px" }}>
                            {prop.bodyText}
                        </div>
                        <div style={{ paddingLeft: "10px", textAlign: "left" }}>
                            <p>Read More ...</p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}
export default IndividualCarroucel;